<template>
  <Nav />
  <Modal>
    <div
      class="h-48 w-48 border-4 border-dashed border-gray-300 rounded-full flex items-center justify-center hover:border-blue-500 transition-all cursor-pointer"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        class="h-24 w-24 text-blue-500"
        @click="downloadCode"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
        />
      </svg>
    </div>
  </Modal>
  <Serial />
  <div id="editor" class="page-height w-full"></div>
</template>

<script>
import { defineComponent, onMounted } from "vue";
import Nav from "@/components/Nav.vue";
import Modal from "@/components/Modal.vue";
import { state } from "@/state";
import { write, getNewFileHandle } from "@/fs.js";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const ace = require("brace");
require("brace/mode/python");
require("brace/theme/dracula");
require("brace/ext/language_tools");

export default defineComponent({
  name: "Home",
  components: {
    Nav,
    Modal
  },
  setup() {
    let editor;

    onMounted(() => {
      editor = ace.edit("editor");
      editor.setOptions({
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
        enableSnippets: true
      });
      editor.commands.addCommand({
        name: "save",
        bindKey: { win: "Ctrl-S", mac: "Cmd-S" },
        exec: function() {
          write();
        }
      });
      editor.getSession().setMode("ace/mode/python");
      editor.setTheme("ace/theme/dracula");
      editor.setShowFoldWidgets(false);
      editor.setFontSize("18px");
    });

    const downloadCode = () => {
      getNewFileHandle().then(() => {
        write();
        state.isModalOpen = false;
      });
    };

    return { state, downloadCode };
  }
});
</script>

<style lang="postcss">
.page-height {
  height: calc(100vh - 4rem);
}

.ace_gutter {
  @apply bg-gray-900 text-white !important;
}

.ace_gutter-active-line {
  @apply bg-gray-800 text-white !important;
}

.ace- {
  @apply bg-gray-800 !important;
}
</style>
